import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useForm, router } from '@inertiajs/react';
import H3 from '../../../../atoms/title/H3';
import Panel from '../../../../atoms/Panel';
import DataTerm from '../../../../atoms/list/DataTerm';
import DataDefinition from '../../../../atoms/list/DataDefinition';
import Button, { ButtonVariants } from '../../../../atoms/Button';
import Ignore from '../../../../atoms/icons/Ignore';
import Favicon from '../../../../atoms/Favicon';
import PageTitle from '../../../../atoms/PageTitle';
import DefinitionList from '../../../../molecules/DefinitionList';
import { CopyrightCheckerDossierTable } from '../../../../organisms/table/CopyrightCheckerDossierTable';
import Layout from '../../../../templates/Layout';
import { ButtonGroup } from '../../../../molecules/ButtonGroup';
import Notice from '../../../../molecules/Notice';
import * as styled from '../../dossiers/:dossierId/CopyrightCheckerDossier.style';
import StatusIndicator from '../../../../atoms/StatusIndicator';
/**
 * @todo check everything by default
 * @todo show number of selected infringements in
 */
function InfringementDetails({ occDomain }) {
    const { t } = useTranslation();
    const [notice, setNotice] = React.useState(null);
    const { data, setData } = useForm({
        detections: [],
        status: 'approved',
    });
    const { patch: patchIgnore } = useForm({ ignored: !occDomain.ignored });
    const handleConfirmAll = () => {
        const confirmedCount = data.detections.length;
        const totalCount = occDomain.photos.reduce((_, p) => {
            return _ + p.detections.length;
        }, 0);
        const newData = confirmedCount !== totalCount
            ? [
                ...occDomain.photos.map(p => p.detections.map(({ id }) => id)),
            ].flat()
            : [];
        setData('detections', newData);
    };
    const handleConfirmGroup = (photo) => {
        const newData = new Set(data.detections);
        const groupConfirmed = photo.detections.every(detection => newData.has(detection.id));
        photo.detections.forEach(({ id }) => {
            if (groupConfirmed) {
                newData.delete(id);
            }
            else {
                newData.add(id);
            }
        });
        setData('detections', [...newData]);
    };
    const handleConfirm = (detection) => {
        const indexOfFound = data.detections.findIndex(id => detection.id === id);
        if (indexOfFound > -1) {
            const newVal = [...data.detections];
            newVal.splice(indexOfFound, 1);
            setData('detections', newVal);
            return;
        }
        setData('detections', [...data.detections, detection.id]);
    };
    const handleIgnore = () => {
        const currentHref = window.location.href;
        const { id: domainId } = occDomain;
        const confirmIgnore = confirm(t('Weet je zeker dat je deze bron wilt negeren?'));
        if (!confirmIgnore)
            return;
        try {
            patchIgnore(`/inbreuken/domeinen/${domainId}/mark-as-ignored`, {
                onSuccess() {
                    router.replace(currentHref);
                    setNotice({
                        type: Notice.Type.SUCCESS,
                        text: t('Bron genegeerd'),
                        title: t('Status'),
                    });
                },
            });
        }
        catch (e) {
            setNotice({
                type: Notice.Type.ERROR,
                text: t(''),
                title: 'Fout',
            });
        }
    };
    return (_jsxs(Layout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('copyright_checker.detail.domein.title') }) }), notice && (_jsx(Notice, { type: notice.type, text: notice.text, title: notice.title })), _jsx(PageTitle, { title: occDomain?.domain, subtitle: t('copyright_checker.detail.domein.title'), href: "/inbreuken/domeinen/", icon: _jsx(Favicon, { domain: occDomain?.domain, size: 24 }) }), _jsxs(styled.Flex, { children: [_jsx(styled.Left, { children: _jsx(CopyrightCheckerDossierTable, { photos: occDomain.photos, confirmed: data.detections, onConfirmAll: handleConfirmAll, onConfirmGroup: handleConfirmGroup, ignoreConfirm: true, onConfirm: handleConfirm, readonly: occDomain.latest_dossier?.status !== 'waiting' }) }), _jsxs(styled.Right, { children: [_jsxs(Panel, { hasNarrowPanelHeight: true, children: [_jsx(H3, { children: "Details" }), _jsxs(DefinitionList, { children: [_jsx(DataTerm, { children: "Domein" }), _jsx(DataDefinition, { children: occDomain.domain })] }), _jsxs(DefinitionList, { children: [_jsx(DataTerm, { children: "Totaal aantal detecties" }), _jsx(DataDefinition, { children: occDomain.detections_count })] }), _jsxs(DefinitionList, { children: [_jsx(DataTerm, { children: "Aantal volle detecties" }), _jsx(DataDefinition, { children: occDomain.full_detections_count })] }), _jsxs(DefinitionList, { children: [_jsx(DataTerm, { children: "Aantal ingesloten detecties" }), _jsx(DataDefinition, { children: occDomain.embedded_detections_count })] }), occDomain.latest_dossier && (_jsxs(DefinitionList, { children: [_jsx(DataTerm, { children: "Status" }), _jsx(DataDefinition, { children: _jsx(StatusIndicator, { status: occDomain.latest_dossier.status }) })] }))] }), _jsx(ButtonGroup, { direction: ButtonGroup.Direction.COLUMN, children: !occDomain.ignored &&
                                    (!occDomain.latest_dossier ||
                                        occDomain.latest_dossier.status ===
                                            'waiting') && (_jsx(Button, { type: "button", variant: ButtonVariants.Gray, fullWidth: true, icon: _jsx(Ignore, { size: 24 }), onClick: handleIgnore, children: t('copyright_checker.ignore_source') })) })] })] })] }));
}
export default InfringementDetails;
